(() => {
  const fulfillmentParam = 'filter.p.m.custom.fulfillment_profile';
  const autoLocaleKey = 'fangster.phase1.locale.auto_done';
  let scheduled = false;

  const phase1Locale = window.FANGSTER_PHASE1_LOCALE || {};
  const languageRoots = phase1Locale.languages || {};

  const normalizeRoot = (root) => {
    let value = String(root || '/');
    if (!value.startsWith('/')) value = `/${value}`;
    return value.endsWith('/') ? value : `${value}/`;
  };

  const currentRoot = normalizeRoot(phase1Locale.currentRoot || '/');

  const hideNode = (node) => {
    if (!node) return;
    node.hidden = true;
    node.setAttribute('aria-hidden', 'true');
  };

  const hideFulfillmentFilters = () => {
    document.querySelectorAll(`input[name="${fulfillmentParam}"]`).forEach((input) => {
      const container = input.closest('details, .facets__disclosure, .mobile-facets__details');
      hideNode(container || input);
    });

    const currentUrl = new URL(window.location.href);
    const hasFulfillmentParam = currentUrl.searchParams.has(fulfillmentParam);
    if (!hasFulfillmentParam) return;

    document.querySelectorAll('facet-remove .active-facets__button').forEach((link) => {
      try {
        const removeUrl = new URL(link.getAttribute('href'), window.location.href);
        if (!removeUrl.searchParams.has(fulfillmentParam)) {
          hideNode(link.closest('facet-remove'));
        }
      } catch (error) {
        // Ignore malformed theme-editor placeholder URLs.
      }
    });
  };

  const rootForLanguage = (isoCode) => {
    const targetCode = String(isoCode || '').toLowerCase();
    const match = Object.entries(languageRoots).find(([code, root]) => {
      return String(code).toLowerCase() === targetCode && root;
    });

    if (!match) return currentRoot;
    return normalizeRoot(match[1]);
  };

  const configuredLocaleRoots = () => {
    return Object.values(languageRoots)
      .filter(Boolean)
      .map(normalizeRoot)
      .filter((root, index, roots) => root !== '/' && roots.indexOf(root) === index);
  };

  const pathHasConfiguredLocaleRoot = () => {
    const path = window.location.pathname.toLowerCase();
    return configuredLocaleRoots().some((root) => {
      const normalizedRoot = root.toLowerCase();
      const rootWithoutSlash = normalizedRoot.replace(/\/$/, '');
      return path === rootWithoutSlash || path.startsWith(normalizedRoot);
    });
  };

  const relativePathForCurrentRoot = () => {
    const path = window.location.pathname || '/';
    const lowerPath = path.toLowerCase();
    const lowerRoot = currentRoot.toLowerCase();
    const rootWithoutSlash = lowerRoot.replace(/\/$/, '');

    if (currentRoot !== '/' && lowerPath === rootWithoutSlash) return '';
    if (currentRoot !== '/' && lowerPath.startsWith(lowerRoot)) {
      return path.slice(currentRoot.length).replace(/^\//, '');
    }

    return path === '/' ? '' : path.replace(/^\//, '');
  };

  const localePathForCurrentPath = (localeRoot) => {
    const root = normalizeRoot(localeRoot);
    const relativePath = relativePathForCurrentRoot();
    return root + relativePath;
  };

  const preferredLanguageCode = () => {
    const shopify = window.Shopify || {};
    const country = String(shopify.country || '').toUpperCase();

    if (country === 'TW') return 'zh-TW';
    if (/^[A-Z]{2}$/.test(country)) return 'en';

    const languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ''];
    const wantsTraditionalChinese = languages.some((language) => {
      const normalizedLanguage = String(language || '');
      return /^zh[-_](?:tw|hk|mo)$/i.test(normalizedLanguage)
        || /^zh[-_]hant(?:[-_](?:tw|hk|mo))?$/i.test(normalizedLanguage);
    });

    return wantsTraditionalChinese ? 'zh-TW' : 'en';
  };

  const preferredLocaleRoot = () => {
    return rootForLanguage(preferredLanguageCode());
  };

  const runFirstVisitLocaleRouting = () => {
    try {
      if (window.localStorage.getItem(autoLocaleKey) === 'true') return;

      const path = window.location.pathname.toLowerCase();
      const isShopifySystemPath = /^\/(cart|checkout|account|localization)(\/|$)/.test(path);

      if (pathHasConfiguredLocaleRoot() || isShopifySystemPath) {
        window.localStorage.setItem(autoLocaleKey, 'true');
        return;
      }

      const targetPath = localePathForCurrentPath(preferredLocaleRoot());
      if (targetPath.toLowerCase() === window.location.pathname.toLowerCase()) {
        window.localStorage.setItem(autoLocaleKey, 'true');
        return;
      }

      window.localStorage.setItem(autoLocaleKey, 'true');
      window.location.replace(targetPath + window.location.search + window.location.hash);
    } catch (error) {
      hideFulfillmentFilters();
    }
  };

  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      hideFulfillmentFilters();
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    runFirstVisitLocaleRouting();
    schedule();
  });

  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  runFirstVisitLocaleRouting();
  schedule();
})();
